<script>
  import { createEventDispatcher } from "svelte";
  import { clearToken, getTokenAttr } from "./auth";
  import List, { Item, Text, Graphic, Separator, Subheader } from "@smui/list";

  let dispatch = createEventDispatcher();

  export let items;
  export let active;

  function logout() {
    clearToken();
    go("/login");
  }

  function go(loc) {
    dispatch("navigate", loc);
  }
</script>

<List>
  {#each items as tab}
    <Item
      href="javascript:void(0)"
      on:click={() => go(`/${tab.resource}`)}
      activated={active === tab.resource}>
      {#if tab.icon}
        <Graphic class="material-icons">{tab.icon}</Graphic>
      {/if}
      <Text>
        <span class="capitalise">{tab.label || tab.resource}</span>
      </Text>
    </Item>
  {/each}
  <Separator nav />
  <Item href="javascript:void(0)" on:click={logout}>
    <Text>Logout ({getTokenAttr('username')})</Text>

  </Item>
</List>
